import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import usePermissions from '@/hooks/use-permissions';
import useSession from '@/hooks/use-session';
import MenuDropdown, { type MenuLink } from '../menu-dropdown';
export type DevelopersDropdownProps = {
  text: string;
  icon: Icon;
  isCollapsed: boolean;
  pathname: string;
};
const DevelopersDropdown = t0 => {
  const $ = _c(44);
  const {
    text,
    icon: Icon,
    isCollapsed,
    pathname
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.privateLayout.nav"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const {
    data: t2
  } = useSession();
  const {
    user
  } = t2;
  const {
    isAuditor
  } = usePermissions();
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = {
      href: "/developers/api-keys",
      text: t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp2);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = {
      href: "/developers/security-logs",
      text: t5
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t(_temp3);
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = {
      href: "/developers/vault-proxy",
      text: t7
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t(_temp4);
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = {
      href: "/developers/webhooks",
      text: t9
    };
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t(_temp5);
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = {
      href: "/developers/sdks",
      text: t11
    };
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t(_temp6);
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = {
      href: "/developers/appearance",
      text: t13
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let subLinks;
  if ($[25] !== t || $[26] !== t10 || $[27] !== t12 || $[28] !== t14 || $[29] !== t4 || $[30] !== t6 || $[31] !== t8 || $[32] !== user?.isFirmEmployee) {
    subLinks = [t4, t6, t8, t10, t12, t14];
    if (user?.isFirmEmployee) {
      let t15;
      if ($[34] !== t) {
        t15 = t(_temp7);
        $[34] = t;
        $[35] = t15;
      } else {
        t15 = $[35];
      }
      let t16;
      if ($[36] !== t15) {
        t16 = {
          href: "/developers/connectors",
          text: t15
        };
        $[36] = t15;
        $[37] = t16;
      } else {
        t16 = $[37];
      }
      subLinks.push(t16);
    }
    $[25] = t;
    $[26] = t10;
    $[27] = t12;
    $[28] = t14;
    $[29] = t4;
    $[30] = t6;
    $[31] = t8;
    $[32] = user?.isFirmEmployee;
    $[33] = subLinks;
  } else {
    subLinks = $[33];
  }
  if (isAuditor) {
    return null;
  }
  let t15;
  if ($[38] !== Icon || $[39] !== isCollapsed || $[40] !== pathname || $[41] !== subLinks || $[42] !== text) {
    t15 = <MenuDropdown text={text} icon={Icon} isCollapsed={isCollapsed} subLinks={subLinks} pathname={pathname} />;
    $[38] = Icon;
    $[39] = isCollapsed;
    $[40] = pathname;
    $[41] = subLinks;
    $[42] = text;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};
export default DevelopersDropdown;
function _temp($) {
  return $.apiKeys;
}
function _temp2($_0) {
  return $_0.securityLogs;
}
function _temp3($_1) {
  return $_1.vaultProxy;
}
function _temp4($_2) {
  return $_2.webhooks;
}
function _temp5($_3) {
  return $_3.sdks;
}
function _temp6($_4) {
  return $_4.appearance;
}
function _temp7($_5) {
  return $_5.connectors;
}